import {NameValueDTO} from '../../../common/models/NameValueDTO';
import {BaseDTO} from '../../../common/models/BaseDTO';

export class CasePaymentLinkDTO extends BaseDTO {
  caseId: number;
  insuredPerson: NameValueDTO;
  provider: NameValueDTO;
  amount: number;
  relatedToTransactionId: number | bigint;
}
